import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Configuration } from '../../../../../models/Configuration';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-configuration-card',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './configuration-card.component.html',
  styleUrl: './configuration-card.component.css'
})
export class ConfigurationCardComponent {

  @Input() configuration!:Configuration;
  protected readonly matchMedia = matchMedia;
    constructor(private sanitizer: DomSanitizer) {}
  
    get safeIconHtml(): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(this.configuration.icon);
    }
}
